import React from 'react';
import { parseISO } from 'date-fns';
import Asterisk from '../common/Asterisk/Asterisk';
import DatePicker from '../common/DatePicker/DatePicker';
import "./CommercialUnit.css";
import { FormError, getFormErrorByName, getFormErrorMessageByName, hasError, useFormErrorContext } from '../../utils/context/FormErrorContext';

interface CommercialUnitDatePickerFieldProps {
    formData: Record<string, unknown>,
    name: string,
    onChange: (date: Date | null | undefined, name: string) => void,
    asterisk?: boolean,
    maxDate?: string | undefined,
    minDate?: string | undefined,
    heading?: string,
    title?: string,
    errors: FormError[],
    id?: string,
    position?: "top" | "bottom" | "right" | "left" | "top-start" | "top-end" | "bottom-start" | "bottom-end" | "right-start" | "right-end" | "left-start" | "left-end",
    disabled?: boolean
}

export default function CommercialUnitDatePickerField(props: CommercialUnitDatePickerFieldProps): JSX.Element {

    const className = hasError(props.errors, props.name) ? "unit-input table-error" : "border unit-input"
    const { removeError } = useFormErrorContext()


    const handleDateChange = (date: Date | null | undefined, name: string) => {
        props.onChange(date, name)
        removeError(getFormErrorByName(props.errors, props.name)?.primaryKey as string)
    }

    return (
        props.heading ? 
        <>
            <tr>
                <td className='label-cell'>
                    {props.heading} {props.asterisk && <Asterisk />}
                </td>
            </tr>
            <tr>
                <td>
                    <DatePicker name={props.name} id={props.id ?? props.name}
                        date={props.formData[props.name] as string | undefined}
                        onChange={handleDateChange}
                        className={className}
                        title={props.title}
                        position={props.position ?? "right-start"}
                        errorMessage={getFormErrorMessageByName(props.errors, props.name)}
                        maxDate={props.maxDate ? parseISO(props.maxDate) : undefined}
                        minDate={props.minDate ? parseISO(props.minDate) : undefined}
                        disabled={props.disabled}
                    />
                </td>
            </tr>
        </>
        :
        <DatePicker name={props.name} id={props.id ?? props.name}
            date={props.formData[props.name] as string | undefined}
            onChange={props.onChange}
            className='border unit-input'
            title={props.title}
            position={props.position ?? "right-start"}
            errorMessage={getFormErrorMessageByName(props.errors, props.name)}
            maxDate={props.maxDate ? parseISO(props.maxDate) : undefined}
            minDate={props.minDate ? parseISO(props.minDate) : undefined}
        />
    );
}
